// ArChat — versión de aplicación inyectada en build (Vite: __APP_VERSION__ desde package.json).
// Tras compilación, coincide con frontend/package.json; fallback solo desarrollo.

// eslint-disable-next-line no-undef
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? String(__APP_VERSION__) : '2.1.12';
export const BUILD_TIMESTAMP = new Date().toISOString();
